import React from 'react';

//Estilos
import { ComponenteExtra380Style } from './ComponenteExtra380Style';

export default function ComponenteExtra1440({ Logo = '' }) {
    return (
        <div style={{ width: '100%' }}>
            <div style={ComponenteExtra380Style.DivStyle}>
                {Logo === null ? null : <img src={Logo} alt="BannerIcon" style={ComponenteExtra380Style.ImgStyle} />}
            </div>
        </div>
    );
}